const FRONTEND = process.env.REACT_APP_FRONTEND_URL;
const BACKEND = process.env.REACT_APP_SERVER_URL;
const WHIPPY = process.env.REACT_APP_WHIPPY_URL;

export default {
  FRONTEND,
  BACKEND,
  WHIPPY,
};
